import {
  SWARVED,
  SWARVED_APP_LINKS,
  SWARVED_CTAS,
  SWARVED_INFOGRAPHICS,
} from "../content/swarved";
import { t } from "../i18n/dict";
import { langFromPath } from "../i18n/lang";
import { Page } from "../layout/Page";
import { Button } from "../ui/Button";
import { Reveal } from "../ui/Reveal";
import { Section } from "../ui/Section";

/**
 * The old site's `/swarved` (and `/swarved-HI`, redirected from as
 * `/hi/swarved`): the intro headline and three paragraphs, the "What is
 * Swarved" infographic, the app-store links, and the three CTAs (Hard
 * Copy, Join Swarved Reading, Swarved Akhand Path).
 */
export function SwarvedPage() {
  const { lang } = langFromPath(window.location.pathname);

  return (
    <Page title="Swarved" heading="Swarved">
      <Section>
        <div className="grid gap-10 lg:grid-cols-[minmax(0,1.1fr)_minmax(0,0.9fr)] lg:items-start">
          <div>
            <h2 className="font-display rule-heading text-2xl text-stone md:text-3xl">
              {SWARVED.heading[lang]}
            </h2>
            <p className="eyebrow mt-3">{SWARVED.composedBy[lang]}</p>
            <div className="mt-6 max-w-xl space-y-4 text-ink-soft">
              {SWARVED.paragraphs.map((paragraph) => (
                <p key={paragraph[lang]}>{paragraph[lang]}</p>
              ))}
            </div>

            <div className="mt-8 flex flex-wrap gap-3">
              {SWARVED_CTAS.map((cta) => (
                <Button key={cta.href} href={cta.href} variant="secondary">
                  {cta.label}
                </Button>
              ))}
            </div>

            <div className="mt-8 flex flex-wrap gap-3">
              <Button href={SWARVED_APP_LINKS.googlePlay} external>
                {t(lang, "getItOnGooglePlay")}
              </Button>
              <Button href={SWARVED_APP_LINKS.appStore} external>
                {t(lang, "downloadOnAppStore")}
              </Button>
            </div>
          </div>

          {SWARVED_INFOGRAPHICS.length > 0 ? (
            <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-1">
              {SWARVED_INFOGRAPHICS.map((image) => (
                <Reveal key={image.src}>
                  <img
                    src={image.src}
                    alt={image.alt}
                    className="w-full rounded-lg border border-hairline"
                    loading="lazy"
                  />
                </Reveal>
              ))}
            </div>
          ) : null}
        </div>
      </Section>
    </Page>
  );
}
